/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMeasurementTypename = "PhrMeasurement" as const;

/**
 *
 * @export
 * @interface PhrMeasurement
 */
export interface PhrMeasurement {
  /**
   *
   * @type {number}
   * @memberof PhrMeasurement
   */
  high?: number;
  /**
   *
   * @type {number}
   * @memberof PhrMeasurement
   */
  low?: number;
  /**
   *
   * @type {string}
   * @memberof PhrMeasurement
   */
  unit?: string;
  /**
   *
   * @type {number}
   * @memberof PhrMeasurement
   */
  value?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMeasurement
   */
  readonly __typename?: string;
}

export function PhrMeasurementFromJSON(json: any): PhrMeasurement {
  return PhrMeasurementFromJSONTyped(json, false);
}

export function PhrMeasurementFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMeasurement {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMeasurementTypename,

    high: !exists(json, "high") ? undefined : json["high"] == "" ? undefined : json["high"],
    low: !exists(json, "low") ? undefined : json["low"] == "" ? undefined : json["low"],
    unit: !exists(json, "unit") ? undefined : json["unit"],
    value: !exists(json, "value") ? undefined : json["value"] == "" ? undefined : json["value"],
  };
}

export function PhrMeasurementToJSON(object?: PhrMeasurement | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    high: (value.high as unknown as string) == "" ? undefined : value.high,
    low: (value.low as unknown as string) == "" ? undefined : value.low,
    unit: value.unit,
    value: (value.value as unknown as string) == "" ? undefined : value.value,
  };
}
